// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__31c_w","bigColWidth":"Table_bigColWidth___Sxx-","biggerColWidth":"Table_biggerColWidth___tkQP","row":"Table_row__1x5S8","col":"Table_col__1alsu"};